import React from 'react';
import { List, Row, Col, Modal, Button } from 'antd';
import Spinner from '../../spinner/spinner';
import { graphql, compose } from 'react-apollo';
import { getFaqAnswers } from "./queries/getFaqAnswers";
import { deleteFaqAnswer } from "./mutations/deleteFaqAnswer";
import { EditButton } from "../../common/editButton/editButton";
import { DeleteButton } from "../../common/deleteButton/deleteButton";
import "./faqAnswersList.css";

const PAGE_SIZE = 10;

class FaqAnswersList extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.stateObject;
  }

  get stateObject() {
    const query = new URLSearchParams(this.props.history.location.search);
    const page = parseInt(query.get('page'), 10);
    if (page) {
      return { currentPage: page, startPageItem: (page - 1) * PAGE_SIZE, endPageItem: page * PAGE_SIZE };
    } else {
      return { currentPage: 1, startPageItem: 0, endPageItem: PAGE_SIZE };
    }
  }

  get pagination() {
    return {
      total: this.props.data.faqAnswers.length,
      pageSize: PAGE_SIZE,
      current: this.state.currentPage,
      onChange: this.onChange
    }
  }

  get dataSource() {
    return this.props.data.faqAnswers.slice(this.state.startPageItem, this.state.endPageItem);
  }

  mutationParams(faqAnswerId) {
    return {
      variables: {
        input: {
          id: faqAnswerId
        }
      }
    };
  }

  faqAnswerQuestion(faqAnswer) {
    return (
      <Row type="flex">
        <Col md={{ span: 20, order: 0 }} xs={{ span: 23, order: 1 }}>
          <p>{faqAnswer.question}</p>
        </Col>
        <Col md={{ span: 3, offset: 0 }} xs={{ span: 6, offset: 15 }} className="faq-answer-edit-link">
          <EditButton link={`/dashboard/admin/faqAnswersList/updateFaqAnswer/${faqAnswer.id}`} className="myclass"/>
        </Col>
        <Col md={{ span: 1 }} xs={{ span: 2 }}>
          <DeleteButton onClick={() => { this.showDeletingModalWindow(faqAnswer.id) }}/>
        </Col>
      </Row>
    )
  }

  findPageByFaqAnswerId() {
    const query = new URLSearchParams(this.props.history.location.search);
    const faqAnswerId = parseInt(query.get('faqAnswer'), 10);
    if (faqAnswerId) {
      const page = Math.ceil((this.props.data.faqAnswers.findIndex((faqAnswer) => faqAnswer.id === faqAnswerId) + 1) / PAGE_SIZE);
      this.props.history.replace(`?page=${page}`);
    }
  }

  onChange = (page) => {
    this.props.history.push(`?page=${page}`);
  };

  async destroyFaqAnswer(faqAnswerId) {
    try {
      this.setState({ loading: true });
      await this.props.mutate(this.mutationParams(faqAnswerId));
    } finally {
      this.onChange(this.state.currentPage);
    }
  }

  showDeletingModalWindow = (faqAnswerId) => {
    Modal.confirm({
      title: "Are you sure you want to delete this FAQ answer?",
      width: 510,
      onOk: () => { this.destroyFaqAnswer(faqAnswerId) }
    });
  };

  render() {
    if (this.props.data.loading) {
      return <Spinner/>;
    } else {
      this.findPageByFaqAnswerId();
      return (
        <div>
          <div className="dashboard-layout__placeholder"/>
          <div className="m-24">
            <List
              itemLayout="vertical"
              size="large"
              pagination={this.pagination}
              dataSource={this.dataSource}
              renderItem={faqAnswer => (
                <Row>
                  <List.Item key={faqAnswer.id}>
                    <List.Item.Meta title={this.faqAnswerQuestion(faqAnswer)}/>
                    {faqAnswer.answer}
                  </List.Item>
                </Row>
              )}
            />
          </div>
        </div>
      );
    }
  }
}

export default compose(
  graphql(getFaqAnswers, {
    options: {
      fetchPolicy: 'network-only'
    }
  }),
  graphql(deleteFaqAnswer)
)(FaqAnswersList);



// WEBPACK FOOTER //
// ./src/components/pages/faqAnswers/faqAnswersList.js